export default {
  'enabled-locations-map': {
    locations: 'Locations',
    'find-my-location': 'Find My Location',
    'select-country': 'Select Country',
    'all-countries': 'All Countries',
    search: 'Search',
    filter: 'Filter by provider, city, country or state',
    'location-type': 'Location Type',
    '100G-enabled': '100G-Enabled',
    'local-ix-available': 'Local IX Available',
    'mcr-enabled': 'MCR-Enabled',
    'mve-enabled': 'MVE-Enabled',
    'view-latency': 'View Latency',
    'enquire-about-this-location': 'Enquire about this location',
    'enabled-location': 'Enabled Location',
    'extended-location': 'Extended Location',
    'loading-locations': 'Loading Locations',
    'no-location-found': 'No location satisfies the filter criteria',
    'closest-mp-enabled-location': 'The closest Megaport Enabled Location is',
    'location-filter': 'Location Filter',
    'coming-soon': 'Coming Soon',
    'enter-your-address': 'Enter your address',
    'learn-about-enabled-extended-locations': 'Learn more about our Enabled and Extended Locations',
    'megaport-supported-location-types': 'Megaport supports two location types where you can reach our network',
    'locations-by-distance': 'Locations by Distance',
    'map-showing-data-center-location': 'Map showing location of data center',
  },
}
